export type Testimonial = {
  initials: string
  quote: string
  name: string
  role: string
  location: string
}

export const heroTestimonials: Testimonial[] = [
  {
    initials: 'JR',
    quote:
      'I planned my entire season in a single evening. Now every session has a clear objective and my students feel the difference.',
    name: 'James R.',
    role: 'Club Coach',
    location: 'London',
  },
  {
    initials: 'CM',
    quote:
      'My students are improving so much faster now that they finally follow a logical progression.',
    name: 'Coach María',
    role: 'Academy Coach',
    location: 'Madrid',
  },
  {
    initials: 'SL',
    quote:
      'I no longer spend hours searching for drills. I open Tennis 360 and everything I need is already there.',
    name: 'Sarah L.',
    role: 'Independent Coach',
    location: 'Sydney',
  },
]

export const testimonials: Testimonial[] = [
  {
    initials: 'JR',
    quote:
      'I planned my whole season in one evening. Every session now has a clear goal and I walk onto the court knowing exactly what we are doing.',
    name: 'James R.',
    role: 'Club Coach',
    location: 'London, UK',
  },
  {
    initials: 'CM',
    quote:
      'My students improved more in two months than in the whole previous year. The progression finally makes sense and they feel it.',
    name: 'Coach María',
    role: 'Academy Coach',
    location: 'Madrid, Spain',
  },
  {
    initials: 'SL',
    quote:
      'I used to spend hours online hunting for drills. Now I open Tennis 360 and everything I need is right there.',
    name: 'Sarah L.',
    role: 'Independent Coach',
    location: 'Sydney, Australia',
  },
  {
    initials: 'DT',
    quote:
      'The evaluation sheets completely changed how I talk to parents. I now speak in numbers and they trust the process.',
    name: 'David T.',
    role: 'Head Coach',
    location: 'Toronto, Canada',
  },
  {
    initials: 'EW',
    quote:
      'As a first-year coach I was completely overwhelmed. Tennis 360 gave me a full professional system from day one.',
    name: 'Emma W.',
    role: 'U12 Girls Coach',
    location: 'Auckland, NZ',
  },
  {
    initials: 'RB',
    quote:
      'The injury return volume saved one of my best students. I knew exactly what to do and he was back on court safely within 6 weeks.',
    name: 'Ryan B.',
    role: 'Senior Coach',
    location: 'Dublin, Ireland',
  },
]
